export enum observationsHistoriqueEnum {
  commentaire_ms = 1,
  commentaire_sbtcp = 2,
  commentaire_drh = 3,
  observations_commission = 4,
}
